"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopSubTitle = exports.DesktopTextTitle = exports.VerticalHR = exports.InfoGraphicContainer = void 0;
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
exports.InfoGraphicContainer = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  background: linear-gradient(180deg, #efe9fb 0%, rgba(239, 233, 251, 0) 100%);
  height: 100%;
`;
exports.VerticalHR = building_blocks_ui_common_1.styled.div `
  width: 1px;
  height: 94px;
  border: 1px solid #e7e7f0;
`;
// TODO-BUILDING_BLOCKS  - need to have guidelines in building blocks
exports.DesktopTextTitle = building_blocks_ui_common_1.styled.p `
  font-weight: 600;
  font-size: 22px;
  line-height: 36px;
  color: #040222;
  text-align: ${(props) => props.textAlign || 'left'};
`;
// TODO-BUILDING_BLOCKS  - need to have guidelines in building blocks
exports.DesktopSubTitle = building_blocks_ui_common_1.styled.p `
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #040222;
  text-align: ${(props) => props.textAlign || 'left'};
  margin: 0;
`;
//# sourceMappingURL=index.js.map